module.exports = __webpack_public_path__ + "media/images/first-interest-image-00e55b6bb29fdb6065d67e83b652388b.png";